  document.addEventListener("DOMContentLoaded", function () {
    $('.instagram-slick').slick({
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 2 }
        }
      ]
    });

    // Reload embeds once DOM is ready
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.related-product-list');
    if (slider) {
      $(slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1 }
          }
        ]
      });
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.crossselling-product-list');
    if (slider) {
      $(slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1 }
          }
        ]
      });
    }
  });

document.addEventListener("DOMContentLoaded", function() {
    // Only run on product pages
    if (!window.location.pathname.includes("/products/")) return;

    // Function to replace Shopify image with full-resolution
    function replaceHighRes(img) {
        if (!img || !img.src.includes("cdn.shopify.com")) return;
        let highRes = img.src.split("&width")[0]; // remove Shopify width param
        img.src = highRes;
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
        img.loading = "eager"; // load immediately
    }

    // Replace existing images in the product gallery
    document.querySelectorAll(".product__media img, .product-gallery img").forEach(replaceHighRes);

    // Observe DOM changes (for lazy-loaded gallery images)
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.tagName === "IMG") {
                    replaceHighRes(node);
                } else if (node.querySelectorAll) {
                    node.querySelectorAll("img").forEach(replaceHighRes);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});



  // document.querySelectorAll('.menu-tab-button').forEach(tab => {
  //   tab.addEventListener('mouseover', function () {
  //     const parentDropdown = this.closest('.menu-mega-dropdown');

  //     parentDropdown.querySelectorAll('.menu-tab-button').forEach(el => el.classList.remove('menu-tab-active'));
  //     parentDropdown.querySelectorAll('.menu-tab-panel').forEach(el => el.classList.remove('menu-tab-active'));

  //     this.classList.add('menu-tab-active');
  //     parentDropdown.querySelector(`#${this.dataset.tab}`).classList.add('menu-tab-active');
  //   });
  // });



// document.addEventListener("DOMContentLoaded", function () {
// const selectors = "h1, h2, h3, h4, h5, h6, p, span, li, a, td, th";
// document.querySelectorAll(selectors).forEach(el => {
//     if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
//      let text = el.textContent.trim();
//      if (text.length > 0) {
//         el.textContent = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//      }
//     }
// });
// });




